/* eslint-disable max-len */
import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import MetaContext from '../../../../contextProviders/MetaContext';

export default function QuestionIcon({ tooltip }) {
  const { branding = {} } = useContext(MetaContext);
  const { primaryColor: brandColor } = branding || {};
  const primaryColor = brandColor || '#7ED321';

  useEffect(() => {
    if (typeof $ === 'undefined') return;

    if (tooltip) {
      $('[data-toggle="m-popover"]').each(function initPopover() {
        const el = $(this);
        const skin = el.data('skin')
          ? `m-popover--skin-${el.data('skin')}`
          : '';

        el.popover({
          trigger: 'hover',
          template: `\
            <div class='m-popover ${skin} popover' role='tooltip'>\
                <div class='arrow'></div>\
                <h3 class='popover-header'></h3>\
                <div class='popover-body'></div>\
            </div>`,
        });
      });
    }
  }, [tooltip]);

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-toggle={tooltip ? 'm-popover' : undefined}
      data-content={tooltip ? tooltip.content : ''}
      data-original-title={tooltip ? tooltip.title : ''}
    >
      <path
        d="M12 0C5.38281 0 0 5.38281 0 12C0 18.6172 5.38281 24 12 24C18.6172 24 24 18.6172 24 12C24 5.38281 18.6172 0 12 0ZM12 2C17.5352 2 22 6.46484 22 12C22 17.5352 17.5352 22 12 22C6.46484 22 2 17.5352 2 12C2 6.46484 6.46484 2 12 2ZM12 6C9.80078 6 8 7.80078 8 10H10C10 8.88281 10.8828 8 12 8C13.1172 8 14 8.88281 14 10C14 10.7656 13.5078 11.4453 12.7812 11.6875L12.375 11.8125C11.5586 12.082 11 12.8633 11 13.7188V15H13V13.7188L13.4062 13.5938C14.9453 13.082 16 11.6211 16 10C16 7.80078 14.1992 6 12 6ZM11 16V18H13V16H11Z"
        fill={primaryColor}
      />
    </svg>
  );
}

QuestionIcon.propTypes = {
  tooltip: PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  }),
};

QuestionIcon.defaultProps = {
  tooltip: null,
};
